import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import { ARTICLES } from "@/data/blogArticles";

// Vite eager:false glob — each file becomes a () => Promise<Module> entry.
const blogModules = import.meta.glob<{ default: ComponentType }>("./pages/blog/*.tsx");

function slugToFilename(slug: string): string {
  const path = slug.replace(/^\/?blog\//, "").replace(/^\/+/, "");
  return path
    .split("-")
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");
}

export interface BlogRouteEntry {
  slug: string;
  Component: LazyExoticComponent<ComponentType>;
}

export const BLOG_ROUTES: BlogRouteEntry[] = [];

for (const article of ARTICLES) {
  const filename = slugToFilename(article.slug);
  const modulePath = `./pages/blog/${filename}.tsx`;
  const loader = blogModules[modulePath];
  if (!loader) {
    if (import.meta.env.DEV) {
      console.warn(
        `[blogRoutes] No module for slug ${article.slug} → expected ${modulePath}. Add the file or fix the slug in blogArticles.ts.`
      );
    }
    continue;
  }
  BLOG_ROUTES.push({ slug: article.slug, Component: lazy(loader) });
}
